module.exports = {"friend":"Mate","site-title":"Stock Loads","site-title.brief":"Stock Loads","terms":{"bill-of-lading":"Delivery Docket","bill-of-lading.abbr":"Docket","vendor":"Supplier","billable-expense":"Reimbursable Expense"},"components":{"loadboard":"Aussie Load Board","load-details":{"self-contracted":"@:booked-load.producer"},"booked-load":{"owner":"@:booked-load.planner"}},"company-profile":{"load-chute":"Loading Ramp","load-chutes":"Loading Ramp | Loading Ramps","vendor-tax-document":"ABN"},"booked-load":{"producer":"Seller","producers":"Seller | Sellers"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en-AU.json
// module id = /W3d
// module chunks = 1